export default __webpack_public_path__ + "static/media/IconDesc_Drone.256.72222597.png";